require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).SortAscending = e.SortAscending || {}, e.SortAscending.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function n(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var a = n(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function c() {
    return c = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, c.apply(this, arguments);
  }

  function u(e, r) {
    if (null == e) return {};

    var t,
        l,
        n = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          n = {},
          a = Object.keys(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || (n[t] = e[t]);
      }

      return n;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }

  function f(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      d,
      b = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var p = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        n = e.size,
        i = void 0 === n ? 16 : n,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        O = e.fill,
        C = e.role,
        h = void 0 === C ? "img" : C,
        v = u(e, p),
        j = t.css(s || (s = f(["\n    color: ", ";\n  "])), O),
        w = t.css(d || (d = f(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var l,
          n,
          a = t["aria-label"],
          i = t["aria-labelledby"],
          c = t.title;

      switch (e) {
        case "img":
          return a || i || c ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", a), o(l, "title", c), l) : {
            "aria-label": (n = r, "".concat(n.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(h, "SortAscending", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return a.createElement("svg", c({
      className: t.cx(o({}, j, null != O), w, l),
      height: "number" == typeof i ? i : b[i],
      width: "number" == typeof i ? i : b[i],
      role: h
    }, x, v, {
      viewBox: "0 0 16 16"
    }), a.createElement("path", {
      d: "M4.44991 1.14265C4.23029 0.95245 3.90429 0.952449 3.68466 1.14265L1.20302 3.29182C0.793944 3.64609 1.04449 4.31811 1.58564 4.31811H2.89835V13.6696C2.89835 14.3152 3.4217 14.8386 4.06729 14.8386C4.71287 14.8386 5.23623 14.3152 5.23623 13.6696V4.31811H6.54893C7.09009 4.31811 7.34063 3.64609 6.93156 3.29182L4.44991 1.14265Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7H14C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5H8Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M7 9C7 8.44772 7.44772 8 8 8H12C12.5523 8 13 8.44772 13 9C13 9.55229 12.5523 10 12 10H8C7.44772 10 7 9.55229 7 9Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11H8Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "SortAscending", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});